export default __webpack_public_path__ + "static/media/obj9.519651d0.jpg";